import { Button, Modal } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

type Props = {
  isOpen: boolean;
  onConfirmDevice: (validateTrustedDevice: boolean) => void;
};

export const TrustDeviceModal = ({ isOpen, onConfirmDevice }: Props) => {
  const { t } = useTranslation('global');

  return (
    <Modal
      isOpen={isOpen}
      title={t('profile.trustedDevices.confirmationModal.title')}
      iconName="shield-star"
      iconVariant="info"
      actions={[
        <Button
          key="cancel"
          variant="secondaryNeutral"
          text={t('profile.trustedDevices.confirmationModal.notNow')}
          onClick={() => onConfirmDevice(false)}
        />,
        <Button
          key="confirm"
          variant="primaryBrand"
          text={t('profile.trustedDevices.confirmationModal.trust')}
          onClick={() => onConfirmDevice(true)}
        />,
      ]}
    >
      <p>{t('profile.trustedDevices.confirmationModal.description')}</p>
    </Modal>
  );
};
